const AccountPrivacyPage = () => (
  <div className="space-y-4" data-testid="account-privacy-page">
    <h2 className="text-2xl font-semibold" data-testid="account-privacy-title">
      Account privacy
    </h2>
    <p className="text-sm text-muted-foreground" data-testid="account-privacy-placeholder">
      Privacy controls will live here soon.
    </p>
  </div>
);

export default AccountPrivacyPage;
